import { FC } from 'react'
import { getUserImage } from 'helpers/getUserImage'
import { Button, Checkbox } from '@wellesley/ui'
import { getDisplayUsername, UserAvatar } from '@wellesley/user'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'
import { AtSign, CornerDownLeft } from 'lucide-react'
import { isUser, checkIsItemSelected } from '../helpers'
import { ListItem } from '../types'

type CmpProps = {
  dropdownList: ListItem[]
  onItemClick: (item: ListItem) => void
  selectedList: ListItem[]
  isEmail?: boolean
}

const DropdownList: FC<CmpProps> = ({
  dropdownList,
  onItemClick,
  selectedList,
  isEmail,
}) => {
  return (
    <>
      {dropdownList.map((item) => (
        <div
          className="max-w-full cursor-pointer"
          key={isUser(item) ? item.id : item}
        >
          {isUser(item) ? (
            <div className="mb-xxxs rounded-m p-xxs flex  items-center justify-between hover:bg-gray-100">
              <div
                className="gap-xxs flex grow items-center"
                onClick={() => onItemClick(item)}
              >
                <UserAvatar
                  size={40}
                  name={item.displayName}
                  imgUrl={getUserImage({
                    type: 'avatar',
                    user: item,
                  })}
                />
                <div className="text-base">
                  <div className="font-medium text-gray-900">
                    {item.displayName}
                  </div>
                  <div className="text-gray-500">
                    {getDisplayUsername(getUserNameWithDomain(item))}
                  </div>
                </div>
              </div>
              <Checkbox
                onCheckedChange={() => onItemClick(item)}
                checked={checkIsItemSelected(selectedList, item)}
              />
            </div>
          ) : (
            <div
              className="mb-xxxs rounded-m p-xxs flex items-center justify-between hover:bg-gray-100"
              onClick={() => onItemClick(item)}
            >
              <div className="gap-xxs flex items-center">
                {isEmail && (
                  <div className="size-m flex items-center justify-center rounded-full bg-gray-100">
                    <AtSign size={20} className="text-gray-500" />
                  </div>
                )}
                {item}
              </div>
              {isEmail && (
                <Button variant="secondary" size="s">
                  Add Email <CornerDownLeft size={16} />
                </Button>
              )}
            </div>
          )}
        </div>
      ))}
    </>
  )
}

export default DropdownList
